<template>
  <div class="tip">
    <div v-for="it of data" :key="it.img" class="tip-item">
      <img :src="it.img" />
      <span class="text">{{ it.text }}</span>
    </div>
  </div>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import { useConfig } from './config';

const props = defineProps({
  type: { type: String, default: '' },
});

const config = useConfig();
const data = computed(() => config[props.type]);
</script>

<style lang="scss">
.tip {
  display: flex;
  flex-wrap: wrap;
  &-item {
    width: 50%;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #6b7280;
    text-align: left;
    padding-left: 16px;
    &:nth-child(odd) {
      text-align: right;
      align-items: end;
      padding-right: 16px;
      padding-left: 16px;
    }
    &:nth-child(even) {
      // padding-right: 16px;
    }
    &:nth-child(n + 3) {
      margin-top: 10px;
    }
    .text {
      margin-top: 8px;
    }
    img {
      width: 72px;
    }
  }
}
</style>
